module.exports = __webpack_public_path__ + "images/store_case_study/belmond-pic2_06897596ad233dc9976377bcf450fb0a.jpg";